/**
 * Mock 模块：heart_voyage_jump_room
 * 文件名须与 mockMd/heart_voyage_jump_room.md 同名（仅扩展名 .ts）。
 * @see mockMd/heart_voyage_jump_room.md
 */
import type {JumpRoomData} from '../types'

/** @see mockMd/heart_voyage_jump_room.md */
export const HeartVoyageJumpRoomMock: JumpRoomData = {
  err_msg: '',
  room_id: 88888,
}
